import { useContext } from 'react'
import { Link } from '@/components/Link'
import { URL_DPV_MANAGE } from '@/config/account'
import { AccountContext } from '@/context/AccountContextDpv'
import { useDpvAboLink } from '@/hooks/useDpvAboLink'
import Popup from '@/components/Popup/Popup'
import { Typography } from '@/components/Typography'
import styles from '../AccountPopup/AccountPopup.module.scss'

const AccountPopup = ({
  isOpen,
  setIsOpen,
}: {
  isOpen?: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const accountContext = useContext(AccountContext)
  const dpvAboLink = useDpvAboLink()
  const onLogout = () => {
    accountContext?.logout?.()
  }

  return (
    <>
      {isOpen && (
        <Popup title="Konto" setIsOpen={setIsOpen}>
          {!accountContext && <div className={styles.loading}>Loading...</div>}
          {accountContext && (
            <>
              <div className={styles.account}>
                <Typography as="span" variant="m" weight="bold">
                  {(accountContext.userInfo?.name ? accountContext.userInfo.name + ' ' : '') +
                    (accountContext.userInfo?.surname ? accountContext.userInfo.surname : '')}
                </Typography>
                {accountContext.userInfo?.hasSubscription && (
                  <Typography as="span" variant="s">
                    PUR Abo
                  </Typography>
                )}
                {accountContext.userInfo?.paidContent.includes('finance') && (
                  <Link href="https://www.n-tv.de/mediathek/videos/etf-masterclass/" target="_blank">
                    <Typography as="span" variant="s">
                      hier geht’s zur ETF-Masterclass
                    </Typography>
                  </Link>
                )}
              </div>

              <Link href={URL_DPV_MANAGE} target="_blank">
                <Typography as="span">Konto verwalten</Typography>
              </Link>
              <Link href={dpvAboLink} target="_blank">
                <Typography as="span">Werbefrei mit dem PUR-Abo</Typography>
              </Link>
              {!accountContext.userInfo?.paidContent.includes('finance') && (
                <Link href="https://finanzen.n-tv.de/etf-masterclass" target="_blank">
                  <Typography as="span">ntv ETF-Masterclass kaufen</Typography>
                </Link>
              )}
              <Link href="/newsletter/">
                <Typography as="span">Newsletter abonnieren / verwalten</Typography>
              </Link>
              <div className={styles.footer}>
                <button onClick={onLogout}>Abmelden</button>
              </div>
            </>
          )}
        </Popup>
      )}
    </>
  )
}

export default AccountPopup
